import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useContext } from "react";
import { CreateReportFormContext } from "../../../../../../shared/context/create-report/create-report-context";

interface IProps {}

function ReportMiscDetailsComponent(props: IProps) {
  const { createReportForm, dispatch } = useContext(CreateReportFormContext)!;

  return (
    <Grid container direction="column" spacing={2}>
      <Grid
        item
        container
        spacing={2}
        justifyContent="start"
        alignItems="center"
      >
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            id="report-name"
            label="Report Name"
            variant="outlined"
            value={createReportForm.reportName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { reportName: event.target.value },
              });
              if (createReportForm.errors.reportNameError) {
                dispatch({
                  type: "UPDATE_ERROR",
                  payload: { field: "reportNameError", value: "" },
                });
              }
            }}
            error={!!createReportForm.errors.reportNameError}
            helperText={createReportForm.errors.reportNameError}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            id="report-description"
            label="Report Description"
            placeholder="Description"
            value={createReportForm.reportDescription}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { reportDescription: event.target.value },
              });
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid
        item
        container
        spacing={2}
        justifyContent="start"
        alignItems="center"
      >
        <Grid item xs={12} sm={6}>
          <FormControl
            fullWidth
            size="small"
            error={!!createReportForm.errors.categoryError}
          >
            <InputLabel>Category</InputLabel>
            <Select
              value={createReportForm.category}
              label="Category"
              onChange={(e: SelectChangeEvent) => {
                dispatch({
                  type: "UPDATE",
                  payload: { category: e.target.value },
                });
                if (createReportForm.errors.categoryError) {
                  dispatch({
                    type: "UPDATE_ERROR",
                    payload: { field: "categoryError", value: "" },
                  });
                }
              }}
            >
              <MenuItem value="Chargebacks">Chargebacks</MenuItem>
              <MenuItem value="Government Pricing">Government Pricing</MenuItem>
              <MenuItem value="Gross To Net">Gross To Net</MenuItem>
              <MenuItem value="Medicaid">Medicaid</MenuItem>
              <MenuItem value="MS reports">MS reports</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
              <MenuItem value="Sales Analytics">Sales Analytics</MenuItem>
            </Select>
            <FormHelperText>
              {createReportForm.errors.categoryError}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            fullWidth
            size="small"
            error={!!createReportForm.errors.permissionsError}
          >
            <InputLabel>Rights</InputLabel>
            <Select
              value={createReportForm.permissions}
              label="Rights"
              onChange={(e: SelectChangeEvent) => {
                dispatch({
                  type: "UPDATE",
                  payload: { permissions: e.target.value },
                });
                if (createReportForm.errors.permissionsError) {
                  dispatch({
                    type: "UPDATE_ERROR",
                    payload: { field: "permissionsError", value: "" },
                  });
                }
              }}
            >
              <MenuItem value="Private">Private</MenuItem>
              <MenuItem value="Full Access">Full Access</MenuItem>
              <MenuItem value="Read Only">Read Only</MenuItem>
              <MenuItem value="View Only">View Only</MenuItem>
              <MenuItem value="Locked">Locked</MenuItem>
            </Select>
            <FormHelperText>
              {createReportForm.errors.permissionsError}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TextField
          size="small"
          id="recipients-id"
          label="Recipients"
          placeholder="Recipients"
          multiline
          value={createReportForm.emailRecipients}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: "UPDATE",
              payload: { emailRecipients: event.target.value },
            });
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          size="small"
          id="exportData"
          label="Export Data"
          placeholder="Enter data here..."
          multiline
          rows={4}
          value={createReportForm.exportData || ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: "UPDATE",
              payload: { exportData: event.target.value },
            });
          }}
          variant="outlined"
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

export default ReportMiscDetailsComponent;
